
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41234)"}},[_c('path',{attrs:{"d":"M21.93 7.837H3.073c-.947 0-1.715.768-1.715 1.715v12c0 .946.768 1.714 1.715 1.714H21.93c.947 0 1.714-.768 1.714-1.714v-12c0-.947-.767-1.715-1.714-1.715zM1.358 14.695h22.286M12.499 12.98v3.428"}}),_c('path',{attrs:{"d":"M17.644 7.838a5.143 5.143 0 00-5.143-5.143v0a5.143 5.143 0 00-5.143 5.143"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41234"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .12)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    